import React, { useContext } from "react"
import { SiteContext } from "../site/siteContext"

export const TEXTFORMATS = {
  NONE: '',
  NUMERIC: 'numeric',
  DATE: 'date',
  TIME: 'time',
  EMAIL: 'email',
  HTML: 'HTML',
  URL: 'URL'
}

/**
 * Text
 */
export const Text = ({ format, children, className }) => {

  const site = useContext(SiteContext)
  let value = children

  if (site) {
    const { lang, dictionary = {} } = site
    const term = dictionary[children]
    const text = term ? term[lang] : children
    if (text) value = text 
  }
  
  const formatter = Intl.NumberFormat()
  switch (format) {
    case TEXTFORMATS.NUMERIC: value = formatter.format(children); break;
  }

  return children ? <span className={className}>{value}</span> : ''

}